import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CookieConsentBanner from "./CookieConsentBanner";

export default function Layout({ children }) {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      // Give the page a tick to render before looking for the target id —
      // otherwise this races the new page's own first render.
      const id = hash.slice(1);
      const t = setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 0);
      return () => clearTimeout(t);
    }
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [pathname, hash]);
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
      <CookieConsentBanner />
    </>
  );
}
